export interface DeliveryStatus {
    value: number;
    label: string;
}

export class DeliveryStatusHelper {

    static create(): DeliveryStatus {
        return {
            value: 0,
            label: ''
        };
    }

    static transformFromAPI(apiData: DeliveryStatus): DeliveryStatus {
        const deliveryStatus = DeliveryStatusHelper.create();
        deliveryStatus.value = apiData['ES_CODIGO'];
        deliveryStatus.label = apiData['ES_DESCRIPCION'];
        return deliveryStatus;
    }
}
